import { IGetters } from '@/interfaces/Store';
import { IThumbedReview } from '@/interfaces/IThumbedReview';
import { IUniversity } from '@/interfaces/IUniversity';
import { IReview } from '../interfaces/IReview';
import { UNIVERSITY_RATINGS } from '../interfaces/UniversityRatings';
import state from './state';
import { IGSSAResults } from '@/interfaces/IGSSAResults';

const getters: IGetters = {
	isLoggedIn: (): boolean => {
		return state.loggedIn;
	},
	reviews: (universityId: number): IReview[] => {
		return state.reviewsPerUniversity.get(universityId) ?? [];
	},
	flaggedReviews: (): number[] => {
		return state.flaggedReviews;
	},
	thumbedReviews: (): IThumbedReview[] => {
		return state.thumbedReviews;
	},
	universities: (): IUniversity[] => {
		return state.universities;
	},
	findUniversityById: (universityId: number): IUniversity | null => {
		return state.universities.find((university) => university.id === universityId) ?? null;
	},
	findThumbedReviewById: (reviewId: number): IThumbedReview | null => {
		return state.thumbedReviews.find((review) => review.reviewId === reviewId) ?? null;
	},
	universityIsValid: (id: number): boolean => {
		const university = state.universities.find((_) => _.id === id);
		const average = university?.rating?.average;

		if (average === null || average === undefined) {
			return false;
		}

		return average >= UNIVERSITY_RATINGS.MIN_AVERAGE;
	},
	averageRatingQuantityIsValid: (id: number): boolean => {
		const university = state.universities.find((_) => _.id === id);
		const quantity = university?.rating?.quantity;
		if (quantity === null || quantity === undefined) {
			return false;
		}

		return quantity >= UNIVERSITY_RATINGS.MIN_QUANTITY;
	},
	showWidgetReviewsAll: (): boolean => {
		return state.showPopup;
	},
	loadWidgetReviewsAll: (): boolean => {
		return state.loadPopup;
	},
	getGssaResults: (): Map<number, IGSSAResults | null> => {
		return state.gssaResults;
	},
	getGssResultByUniversityId: (universityId: number): IGSSAResults | null => {
		return state.gssaResults.get(universityId) ?? null;
	},
	reviewsPerUniversity: (): Map<number, IReview[]> => {
		return state.reviewsPerUniversity;
	},
	showWidgetReviewsAllPerUniversity: (): Map<number, boolean> => {
		return state.showPopupPerUniversity;
	},
};

export default getters;
